import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScriptHeader } from '../styles';

export const SectionTwo = ({ details }) => {
    const { t } = useTranslation();
    const { avgCreditUsage } = details;

    return (
        <>
            <ScriptHeader>{t('your_analysis.script.10')}</ScriptHeader>
            <div>{t('your_analysis.script.11')}</div>
            <div>
                <p>
                    {t('your_analysis.script.12')}
                    <strong>{avgCreditUsage}</strong>
                    {t('your_analysis.script.13')}
                </p>
                <p>{t('your_analysis.script.14')}</p>
            </div>
        </>
    );
};
